import { FiClock } from "react-icons/fi";
import { formatDate, formatTime } from "../../utils/formatDate";

const TimeSlotPicker = ({
  selectedDate,
  slots = [],
  selectedStartTime = "",
  onSelectSlot,
  error = "",
  loading = false,
  title = "Available Times",
}) => {
  return (
    <div className="w-full">
      <div className="flex items-center gap-2">
        <FiClock className="text-henna" />
        <h3 className="text-lg font-semibold text-henna">{title}</h3>
      </div>

      {!selectedDate ? (
        <div className="mt-5 rounded-[28px] border border-goldlight bg-soft-cream p-6">
          <p className="text-base text-muted-warm">
            Please choose a date first to see available appointment times.
          </p>
        </div>
      ) : (
        <>
          <div className="mt-5 rounded-[28px] bg-soft-cream p-5">
            <p className="text-base font-semibold text-henna">Selected Date</p>
            <p className="mt-3 text-2xl font-medium text-[#2f2626]">
              {formatDate(selectedDate)}
            </p>
          </div>

          {loading ? (
            <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
              {[...Array(9)].map((_, i) => (
                <div
                  key={i}
                  className="h-24 animate-pulse rounded-2xl border border-goldlight bg-soft-cream"
                />
              ))}
            </div>
          ) : slots.length === 0 ? (
            <div className="mt-6 rounded-[28px] border border-goldlight bg-soft-cream p-6">
              <p className="text-base text-muted-warm">
                There are no available time slots for this date.
              </p>
            </div>
          ) : (
            <div className="mt-6 grid grid-cols-1 gap-2 sm:grid-cols-2 xl:grid-cols-3">
              {slots.map((slot) => {
                const isSelected = selectedStartTime === slot.startTime;

                return (
                  <button
                    key={`${slot.startTime}-${slot.endTime}`}
                    type="button"
                    onClick={() => onSelectSlot(slot)}
                    className={[
                      "min-h-[50px] rounded-2xl border px-2 py-3 text-center transition-all duration-200",
                      isSelected
                        ? "border-henna bg-henna text-white shadow-soft"
                        : "border-henna bg-white text-henna hover:bg-soft-cream hover:shadow-soft",
                    ].join(" ")}
                  >
                    <div className="text-1xl font-semibold leading-none">
                      {formatTime(slot.startTime)}
                    </div>

                    <div
                      className={[
                        "mt-4 text-sm font-medium",
                        isSelected ? "text-white/90" : "text-[#8b5e5e]",
                      ].join(" ")}
                    >
                      until {formatTime(slot.endTime)}
                    </div>
                  </button>
                );
              })}
            </div>
          )}
        </>
      )}

      {error ? <p className="field-error mt-4">{error}</p> : null}
    </div>
  );
};

export default TimeSlotPicker;